/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.modals.controllers', [])

.controller('PosPublishModalController', ['$scope', '$uibModalInstance', 'terminals', 'emptyPages', function($scope, $uibModalInstance, terminals, emptyPages) {

    $scope.posPublishModal = {

      terminals: terminals.data.payload || [],
      emptyPages: emptyPages || [],

      confirm: function () {
        $uibModalInstance.close(true);
      },

      cancel: function () {
        $uibModalInstance.dismiss();
      },

      isAssigned: function () {
        return ($scope.posPublishModal.terminals.length > 0);
      }

    };


}]);